import React from 'react';
import I18n from 'i18n-js';
import { RCModal } from '@reverbdotcom/cadence/components';
import { PaymentAction } from '@adyen/adyen-web/dist/types/types';
import { SCAState, useAdyenSCA } from './adyen_sca_hook';

interface Props {
  action: PaymentAction;
  onAdditionalDetails(state?: SCAState): void;
}

export default function SCAChallengeShopper(props: Props) {
  const [isOpen, setOpen] = React.useState(true);

  function onAdditionalDetails(state: SCAState) {
    setOpen(false);
    props.onAdditionalDetails(state);
  }

  // Adyen doesn't provide their own cancellation callback,
  // so if the user cancels the challenge flow (like closing the modal),
  // onComplete is triggered with a result that will cause the
  // 3DS submission process to fail gracefully.
  function onCancel() {
    setOpen(false);
    props.onAdditionalDetails(null);
  }

  return (
    <RCModal
      isOpen={isOpen}
      onOpenChange={(open) => { if (!open) onCancel(); }}
      title={I18n.t('discovery.scaChallengeShopper.title')}
    >
      <ChallengeShopperForm action={props.action} onAdditionalDetails={onAdditionalDetails} />
    </RCModal>
  );
}

function ChallengeShopperForm({ action, onAdditionalDetails }) {
  useAdyenSCA({ selector: '[data-3ds-challenge-shopper]', action, onAdditionalDetails });
  return <div data-3ds-challenge-shopper />;
}
